<template>

  <b-card>
    <b-col cols="12" class="pr-0 pl-0 mt-2">
      <h5 class="text-right my-1 mx-1">Resultados: {{pagination.rows}}</h5>
      <b-table 
        v-if="!loadingTable && interconsultasFiltradas.length > 0" 
        striped responsive
        :per-page="table.perPage"
        :items="interconsultasFiltradas" 
        :fields="fieldsTable" 
        sort-by.sync=""
        sort-desc.sync=false 
        sort-direction="asc"
      >
        <template #cell(check)="data">
          <b-form-checkbox 
            :value="data.item.id" 
          >
          </b-form-checkbox>
        </template>

        <template #cell(estado)="data">
          <div 
            class="estado"
            :class="data.item.estado.value === '99' ? 'estado-completar' : 'estado-completado'"
          >
            {{ data.item.estado.text }}
          </div>
        </template>

        <template #cell(acciones)="data">
          <div class="d-flex justify-content-around">
            <b-button
              v-if="data.item.estado && data.item.estado.value === '99'"
              @click="onCompleteInterconsulta(data.item.token)"
              v-b-tooltip.hover 
              title="Completar Interconsulta"
              variant="success"
              size="sm"
            >
              C
            </b-button>

            <b-button
              v-if="data.item.estado && data.item.estado.value === '1'"
              @click="onCompleteInterconsulta(data.item.token)"
              v-b-tooltip.hover 
              title="Completar Interconsulta"
              variant="warning"
              size="sm"
            >
              E
            </b-button>

            <b-button
              @click="onViewInterconsulta(data.item.token)"
              v-b-tooltip.hover 
              title="Ver Detalles"
              variant="info"
              size="sm"
            >
              <font-awesome-icon icon="magnifying-glass" style="color: white;" />
            </b-button>

            <b-button
              v-if="data.item.estado && data.item.estado.value === '99'"
              @click="onDeleteInterconsulta(data.item.token)"
              v-b-tooltip.hover 
              title="Eliminar"
              variant="danger"
              size="sm"
            >
              <i class="fas fa-trash"/>
            </b-button>
            <b-button
              v-if="data.item.estado && data.item.estado.value !== '99'"
              @click="onViewFile007(data.item.token)"
              v-b-tooltip.hover 
              title="Descargar Form 007"
              
              size="sm"
            >
              <i class="fa-solid fa-file-arrow-down"></i>
            </b-button>
          </div>
        </template>
      </b-table>

      <div 
        v-if="interconsultasFiltradas.length === 0 && !loadingTable"
        class="text-center"
      >
        <EmptyResults/>
      </div>

      <b-skeleton-wrapper v-if="loadingTable">
        <b-skeleton 
          v-for="i in 15"
          :key="i"
          width="100%" 
          height="50px"
        />
      </b-skeleton-wrapper>

      <div class="d-flex justify-content-center">
        <b-pagination
          v-if="interconsultasFiltradas.length > 0"
          v-model="pagination.currentPage"
          
          :total-rows="pagination.rows"
          :per-page="table.perPage"
          aria-controls="my-table"
          @change="onChangePage"
        />
      </div>
    </b-col>

    <ModalViewFile
      v-if="modalFile.fileToView"
      :urlFile="modalFile.fileToView"
      :rutaCompleta=modalFile.isRutaCompleta
      v-model="modalFile.isVisible"
    />
  </b-card>

</template>



<script>
import { mapState } from 'vuex';
import { EmptyResults, ModalViewFile } from '@/shared/components';
import { especialidadService, authService } from '@/shared/services';
import { interconsultaService } from '../../services';
import { interconsultaMapper, isJefeMedico } from '../../helpers';

export default {
  name: "TableInterconsultas",

  components: {
    EmptyResults,
    ModalViewFile
  },


  data() {
    return{
      loadingTable: true,
      interconsultas: [],
      interconsultasFiltradas: [],

      doctorLoginId: null,
      
      isJefeMedico: isJefeMedico(),

      table:{
        perPage: 15
      },

      pagination:{
        currentPage: 1,
        rows:0,
      },

      filters:{
        paciente: null,
        doctor: null,
        establecimiento:null,
        estado:null,
        tipo:null
      },

      modalFile:{
        fileToView: null,
        isVisible: false,
        isRutaCompleta: false
      },

      fieldsTable:[
        // { key: 'check',            label: '',                  sortable: true, thClass: 'text-center' },
        { 
          key: 'establecimiento.text',     
          label: 'Establecimiento',      
          sortable: true, 
          thClass: 'text-center' 
        },
        
        { 
          key: 'paciente',         
          label: 'Paciente',          
          sortable: true, 
          thClass: 'text-center' 
        },
        { 
          key: 'estado', 
          label: 'Estado',            
          sortable: true, 
          thClass: 'text-center',
        },

        { 
          key: 'tipo.text', 
          label: 'Tipo',            
          sortable: true, 
          thClass: 'text-center',
        },

        { 
          key: 'fechaInterconsulta',     
          label: 'Fecha',      
          sortable: true, 
          thClass: 'text-center',
        },

        {
          key: 'servicio.text',     
          label: 'Servicio',      
          sortable: true, 
          thClass: 'text-center' 
        },

        { 
          key: 'especialidad.text',     
          label: 'Especialidad',      
          sortable: true, 
          thClass: 'text-center' 
        },

        

        { 
          key: 'doctor',     
          label: 'Doctor',      
          sortable: true, 
          thClass: 'text-center' 
        },

        { 
          key: 'acciones',         
          label: 'acciones',          
          sortable: true, 
          thClass: 'text-center', 
          tdClass: 'text-right' 
        },
        // { key: 'documentos',       label: 'documentos',        sortable: true, thClass: 'text-center', tdClass: 'text-right' },
      ],
    }
  },

  created() {

    this.loadDoctorId().then(() => {
      this.loadDataTable();
    });
  },

  methods:{

    async onViewFile007(tokenInterconsulta) { 
      const urlTemp = await interconsultaService.getUrlView007(tokenInterconsulta);

      if (!urlTemp) {
        this.$swal({
          title: 'Error',
          text: "El archivo no existe, comunicar con el adminsitrador sistema",
          icon: 'error',
        })
      }

      this.modalFile.isRutaCompleta = true;
      this.modalFile.fileToView = urlTemp;
      this.modalFile.isVisible = true;
    },


    onCompleteInterconsulta(token){
      this.$router.push({ name: 'interconsultas', query: { completar: token } })
    },

    onViewInterconsulta(token){
      this.$router.push({ name: 'interconsultas', query: { view_interconsulta: token } })
    },

    onChangePage(page){
      this.pagination.currentPage = page;
      this.loadDataTable();
    },

    onDeleteInterconsulta(token){

      this.$swal({
        title: "¿Estás seguro de eliminar este ítem?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar!",
        cancelButtonText: "Cancelar",
      })
        .then( async (result) => {
          if (result.isConfirmed) {

            const responseDelete = await interconsultaService.deleteByToken(token);
            if( responseDelete ){
              this.$swal("Eliminado!", "El ítem ha sido eliminado.", "success");
              this.loadDataTable();
              return;
            }

            throw new Error("Ocurrio un error al intentar eliminar el ítem.");

          }
        })
        .catch((error) => {
          console.error("Error al eliminar el ítem:", error);

          this.$swal(
            "Error",
            "Ocurrió un error al intentar eliminar el ítem.",
            "error"
          );
        });
    },


    async loadDataTable() {
      this.loadingTable = true;

      const params = {
        ...this.filters,
        page: this.pagination.currentPage,
        pageSize: this.table.perPage
      }

      const data = await interconsultaService.getAll(params);

      if (!data) {
        this.loadingTable = false;
        return;
      }

      const { interconsultas, total } = data;

      this.pagination.rows = total;

      const especialidadesOpts = await especialidadService.getOptionsSelect();

      this.interconsultas = await Promise.all(
        interconsultas.map( i => interconsultaMapper(i, especialidadesOpts) )
      );
      
      this.loadingTable = false;

    },


    async loadDoctorId(){
      const doctorLogin = await authService.getDoctorLogin();
      this.doctorLoginId =  doctorLogin.persona.doctorSet[0]?.id;

      if(this.isJefeMedico) return;
      this.filters.doctor = this.doctorLoginId;
    }
  },


  computed: {
    ...mapState({
      stInterconsultasFilters: state => state.derivaciones.interconsultasFilters,
    }),

    // isJefeMedico(){
    //   const userLoginLS = localStorage.getItem('detalleusuario');
    //   const userLoginDetails = JSON.parse(userLoginLS);

    //   if(!userLoginDetails) return false;

    //   return userLoginDetails?.roles.some( role => role.codigo === '003' );

    // }
  },

  watch: {

    stInterconsultasFilters: {
      deep: true,
      handler(newValue) {

        this.filters = {
          establecimiento    : newValue.establecimiento,
          estadoInterconsulta: newValue.estado,
          paciente           : newValue.paciente?.value,
          doctor             : this.isJefeMedico ? newValue.doctor?.value : this.doctorLoginId,
          tipo               : newValue.tipo
        };


      }
    },

    filters: {
      deep: true,
      handler() {
        this.loadDataTable();
      }
    },


    interconsultas: {
      deep: true,
      handler(newValue) {
        this.interconsultasFiltradas = newValue;
      }
    },
  }
}
</script>

<style>

  .estado{
    color: white;
    padding: 5px;
    border-radius: 5px;
    text-align: center;
  }

  .estado-completar{
    background-color: darkorange;
    
  }

  .estado-completado{
    background-color: green;
  }
</style>